/* eslint-disable no-underscore-dangle, filenames/match-exported */
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers';

import { ErrorsMiddleware } from 'containers/Authenticator';

export default createStore(reducers, applyMiddleware(ErrorsMiddleware, thunk));
/* eslint-enable */
